import { render, staticRenderFns } from "./GenericError.vue?vue&type=template&id=e98178ca"
import script from "./GenericError.vue?vue&type=script&lang=ts"
export * from "./GenericError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports